import { autoinject } from 'aurelia-framework';
import httpStatus from 'http-status';

import { APIParameters, GenericApi } from '~/api/generic-api';
import { FetchUtils } from '~/utils/fetch-utils';

@autoinject
export class AOLIntegrationAPI extends GenericApi {
	public static gotoAOLEndpoint(params: APIParameters): Promise<any> {
		return FetchUtils.get('api/aol-integration/goto', params).then(
			(data) => {
				const contentType: string = data.headers.get('Content-Type');
				if (!contentType) {
					throw new Error(
						'Failed to get Content Type from AOL Integration API response',
					);
				}

				// WEBUI-4769: I have left this as 300 MULTIPLE_CHOICES rather than trying a different 3xx REDIRECTION code
				// because I am not sure about the impact on this AOL integration and there are no current issues with this.
				if (
					data.status === httpStatus.MULTIPLE_CHOICES &&
					contentType.includes('text/plain')
				) {
					return data.text();
				} else if (
					data.status === httpStatus.NOT_FOUND &&
					contentType.includes('application/json')
				) {
					return data.json();
				}

				let errorMessage =
					'Failed to get AOL Integration URL from API response.';
				if (data.status) {
					errorMessage += ' Unhandled status: ' + data.status + '.';
				}
				if (data.statusText) {
					errorMessage += ' Reason: ' + data.statusText + '.';
				}
				throw new Error(errorMessage);
			},
		);
	}
}
